function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import TabItem from './_internal/TabItem';
import HotTabs from './_internal/_HotTabs';
import { getTabId, getPanelId } from './util';
import { ITEMS_PROP_TYPE } from './constants';
import { focusNewPosition, filterNonEmptyItems } from '../hotKeys/util';

var TabContent = function TabContent(_ref) {
  var focusPosition = _ref.focusPosition,
      items = _ref.items;
  var _items$focusPosition = items[focusPosition],
      value = _items$focusPosition.value,
      content = _items$focusPosition.content;
  return React.createElement("div", {
    id: getPanelId(value),
    className: "eds-tabs__content",
    role: "tabpanel",
    "aria-labelledby": getTabId(value)
  }, content);
};

var Tabs =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Tabs, _PureComponent);

  function Tabs(props) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tabs).call(this, props));
    var initialSelectedTab = props.initialSelectedTab;
    _this.state = {
      focusPosition: initialSelectedTab
    };
    return _this;
  }

  _createClass(Tabs, [{
    key: "_changeFocusedTab",
    value: function _changeFocusedTab(e, direction) {
      var _this$props = this.props,
          items = _this$props.items,
          preventFocusWrap = _this$props.preventFocusWrap;
      var focusPosition = this.state.focusPosition;
      var nonEmptyItems = filterNonEmptyItems(items);
      var boundFocusNewPosition = focusNewPosition.bind(null, nonEmptyItems, focusPosition, e, preventFocusWrap);
      this.setState(boundFocusNewPosition(direction));
    }
  }, {
    key: "_handleSelected",
    value: function _handleSelected(newFocusPosition, value) {
      var onTabChange = this.props.onTabChange;
      this.setState({
        focusPosition: newFocusPosition
      });

      if (onTabChange) {
        onTabChange(value);
      }
    }
  }, {
    key: "_getTabItems",
    value: function _getTabItems(items, focusPosition, disabledList) {
      var _this2 = this;

      var tabItems = items.map(function (_ref2, index) {
        var value = _ref2.value,
            displayName = _ref2.displayName;
        return React.createElement(TabItem, {
          key: value,
          value: value,
          onSelected: _this2._handleSelected.bind(_this2, index, value),
          displayName: displayName,
          isSelected: index === focusPosition,
          isDisabled: disabledList.includes(value)
        });
      });
      return tabItems;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          items = _this$props2.items,
          disabledList = _this$props2.disabledList;
      var focusPosition = this.state.focusPosition;

      var tabItems = this._getTabItems(items, focusPosition, disabledList);

      return React.createElement("div", {
        className: "eds-tabs"
      }, React.createElement(HotTabs, {
        onChangeTab: this._changeFocusedTab.bind(this),
        tabItems: tabItems
      }), React.createElement(TabContent, {
        focusPosition: focusPosition,
        items: items
      }));
    }
  }]);

  return Tabs;
}(PureComponent);

_defineProperty(Tabs, "propTypes", {
  /**
   * items: List of items to display in the tab list.
   * Accepts value, displayName, and content
  */
  items: ITEMS_PROP_TYPE.isRequired,

  /**
   * onTabChange: Callback function to be invoked on tab change
  */
  onTabChange: PropTypes.func,

  /**
   * initialSelectedTab: Initial selected tab value
  */
  initialSelectedTab: PropTypes.number,

  /**
   * Whether the navigation for items should be un-wrapped (i.e. no first to last, last to first)
   */
  preventFocusWrap: PropTypes.bool,

  /**
   * List of values for disabled tabs
   */
  disabledList: PropTypes.arrayOf(PropTypes.number)
});

_defineProperty(Tabs, "defaultProps", {
  initialSelectedTab: 0,
  preventFocusWrap: false,
  disabledList: []
});

export default Tabs;